import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetObligationFactory } from "../../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../../theme/Component/Modal";
import { InputDate } from "../../../../../../../theme/Input/InputDate";

interface conf {
    label?: string;
}

interface Props {
    idDocument: number;
    _paymentDate: any;
    onChange: Function;
    configProps?: conf;
    renderValue?: string;
}

export const    OBsBudgetEditor = ({ idDocument, _paymentDate, onChange, configProps, renderValue }: Props) => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_BudgetObligationFactory)
    const [valor, setValor] = useState<string>("")
    const [paymentDate, setPyamentDate] = useState<string>(_paymentDate ?? "")
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (_paymentDate) {
            setPyamentDate(_paymentDate)
        }
    }, [_paymentDate])

    useEffect(() => {
        if (idDocument && paymentDate) {
            getOBS()
        }
    }, [idDocument, paymentDate])

    useEffect(()=>{
        if (renderValue){
            setValor(renderValue)
        }
    },[renderValue])

    const getOBS = () => {
        instance.getObligationBudgetDocumentBudgetList(idDocument, paymentDate).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const getItem = () => {
        if (bean.BudgetIDStr) {
            setModal({ ...modal, "view": false });
            setValor(`${bean.BudgetIDName} - $${bean.OBValue}`);
            if (onChange) {
                onChange(bean);
            }
        } else {
            toast.error("OB no valida")
        }
    }

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente Presupuestal', property: 'BudgetSourceName', visible: true },
        { title: 'Tipo de Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Valor', property: 'OBValue', visible: true, mask: MASK_MONEY },
    ]

    return (
        <>
    {paymentDate}
            <label>{configProps?.label ?? "Rubro Presupuestal"}</label>
            <div className="form-control text-wrap" style={{ minHeight: '35px' }} onClick={() => setModal({ ...modal, "view": true, "name": "Obligaciones Presupuestales del tercero" })}>
                {valor ? (
                    valor
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <div className="row">
                    {!_paymentDate &&
                        <div className="col-md-12">
                            <InputDate name="" value={paymentDate} setDate={(e) => { setPyamentDate(e) }} label="Fecha de Registro Contable" />
                        </div>
                    }
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}